export { default as loadBrands } from './loadBrands';

export type { LoadBrandsFunction, LoadBrandsPayload } from './loadBrands.type';
